/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Boiler } from "./modelBoiler";

class ControllerBoiler extends ControllerModel {
    constructor() {
        super("ControllerBoiler");

        this.setNewNode = (callback) => {
            let boiler = new Boiler();
            boiler.decorate(callback);

            this.addNode(boiler);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let boiler = new Boiler();
            boiler.copyFrom(node);
            boiler.decorate(callback);
            this.addNode(boiler)
        }

        this.getProperties = async (node) => {
            let n = new Boiler();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Boiler();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerBoiler };